

// eslint-disable-next-line
import { handleResponseJson,handleResponseVoid, handleError } from "../../apiUtils";
import { MentorUserInfo } from "../Interfaces/MentorUserInfo";

    /**
    * Gets the user information for a particular mentor.
    **/
    export function userInfo(sessionId: string, authToken:string): Promise<MentorUserInfo>{
        var url = `api/mentor/users/UserInfo?sessionId=${encodeURIComponent(sessionId)}`;
        return (
                fetch(url, 
                {
                    method: "get",
                    headers: { "Authorization": "Bearer " + authToken },
                    body: null
                })
                .then(handleResponseJson)
                .catch(handleError)
               );
    }



